export default "__VITE_ASSET__DtIOf$HW__"